import { ActionsMenu } from "@idwal/idwal-react-components";
import { sendGAEvent } from "../../services/AnalyticsService";
import { REPORTS_ACTION_CLICK, VIEW_REPORT_CLICK } from "../../utils/analytics";

export const actionBodyTemplate = (
    rowData: any, 
    viewInspectionCallback: (rowData: any) => void,
    t: any,
    labelOverride?: string | undefined,
) => {
    const menuItems = [
        {
            label: labelOverride ?? t("inspections.table.viewReport"),
            icon: <img 
                className="pr-2" 
                alt="request_inspection" 
                src="./request-inspection-menu.svg">
            </img>,
            command: () => {
                sendGAEvent(REPORTS_ACTION_CLICK, VIEW_REPORT_CLICK);
                viewInspectionCallback(rowData);
            }
        }
    ];

    if (rowData.inspectionType === "Pre-Sale Inspection") {
        menuItems.push({
            label: t("inspections.table.manageReportDistribution"),
            icon: <i className="pi pi-share-alt pr-2" />,
            command: () => {
                window.open(
                    `https://${process.env.REACT_APP_PRE_SALE_URL}/manage-sharing/${rowData.inspectionGuid}`,
                    "_blank",
                );
            }
        });
    }
    

    return <ActionsMenu menuItems={menuItems}/>
}
